angular.module('wbDashboard').controller('ProfileContactControllerAurea', ['$scope', '$q', 'User', 'Message', function ($scope, $q, User, Message) {
    $scope.pageData.errorMsg = null;

    $scope.preferences = {};
    $scope.preferencesOriginal = {};
    User.retrieveEmailPreferences().then(function(categories) {
        setPreferenceData(categories);
    });


    /**
     * Updating email preferences
     */
    $scope.preferencesChanged = function() {
        return !angular.equals($scope.preferences, $scope.preferencesOriginal);
    };
    $scope.updatePreferences = function() {
        $scope.pageData.sending = true;
        return User.updateEmailPreferences($scope.preferences).catch(function(response) {
            Message.add({
                "text" : "There was an issue updating your information, please refresh to try again or contact support@axosinvest.com if you have any questions.",
                "type" : "warning"
            });
            throw response;
        }).then(function(categories) {
            Message.add({
                "text" : "Your email preferences have been updated",
                "type" : "success"
            });
            setPreferenceData(categories);

        }).finally(function() {
            $scope.pageData.sending = false;
        });
    };
    function setPreferenceData(categories) {
        $scope.categories = categories;
        $scope.preferencesOriginal = {};
        angular.forEach($scope.categories, function(cat) {
            $scope.preferences[cat.name] = cat.allowed;
            $scope.preferencesOriginal[cat.name] = cat.allowed;
        });
    }


    /**
     * Updating mail and phone
     */
    $scope.contactChanged = function() {
        return !angular.equals($scope.userDetails, $scope.userDetailsOrig);
    };
    $scope.updateContact = function() {
        $scope.userSubmit().finally(function() {
            $scope.forms.detail.$setPristine();
        });
    };

    var transitionDeregisterHook = $scope.$transitions.onBefore({exiting: 'base.profile.contact.**'}, function(trans) {
        if (trans.$to().name !== "public.logout") {
            if ($scope.contactChanged() || $scope.preferencesChanged()) {
                if (!confirm("You've changed some of your information, are you sure you want to leave without saving?")) {
                    return false;
                } else {
                    setPreferenceData($scope.categories);
                }
            }
        }
    });
    $scope.$on('$destroy', function() {
        if (transitionDeregisterHook) {
            transitionDeregisterHook();
        }
    });

}]);
